const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0xA0931034f72C83333Efa4a586c583f345202Df0a',
  busdAddress: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
  lpAddress: '0x19e7cbecdd23a16dfa5573df54d98f7caae03019'
}

export default priceContracts